import { Box, Paper, Typography, Grid, TextField, InputAdornment } from "@mui/material";

import React, { useState, useEffect } from "react"; // Import useEffect

function ConsolidatedInvoice({ apiSetting, updateApiSetting }) {
  const labelWidth = 130;
  const [dataList, setDataList] = useState({});


  useEffect(() => {
    setDataList(apiSetting);
  }, [apiSetting]);
 
  const handleChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) { // Regular expression for only digits
      handleCreate("days_interval", event);
    }
  };

  const handleCreate = (property, event) => {
    const inputFormCopy = { ...dataList };    
    inputFormCopy[property] = event.target.value;

    setDataList(inputFormCopy);
    updateApiSetting(inputFormCopy); // Update the parent component
  };

  return (
    
    // <Paper>
      <Box p={3}>
        <Typography variant="h5" fontWeight="fontWeightMedium">
        Config Settings
        </Typography>
        {/* <Grid container spacing={3} sx={{marginBottom:"-24px"}}> */}
          {/* First item in the grid */}
          <Grid item xs={12}  my={3}>  
          <Box display="flex" mb={2} sx={{paddingBottom:"-24px" }}>
          <Typography
            display="flex"
            alignItems="center"
            pr={4}
            sx={{ minWidth: labelWidth}}
          >
            Consolidated Invoice Interval
          </Typography>
          <TextField
                size="small"
                id="days"
                onChange={handleChange}
                value={dataList?.days_interval}
                variant="outlined"
                type="number"
                // fullWidth
                sx={{ width: 200 }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">days</InputAdornment>,
                }}
              />
        </Box>
            {/* <Box display="flex" my={1}>
              <Typography
                display="flex"
                alignItems="center"
                px={4}
                sx={{ minWidth: labelWidth }}
              >
                Frequency :
              </Typography> */}
              {/* <TextField
                size="small"
                id="days"
                onChange={handleChange}
                value={dataList?.days_interval}
                variant="outlined"
                type="number"
                sx={{ width: 200 }}
                InputProps={{
                  endAdornment: <InputAdornment position="end">days</InputAdornment>,
                }}
              />
            </Box> */}
            {/* <Box display="flex" mt={3} px={4}> */}
            {/* <Typography
                display="flex"
                alignItems="center"
                justifyContent="start"
                px={4}
                sx={{ minWidth: labelWidth }}
              >
                Invoice Per Line :
              </Typography> */}
    
              {/* <FormControl>
                <RadioGroup
                row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={value}
                  onChange={handleCreate}
                >
                  <FormControlLabel value="single" control={<Radio />} label="Single Invoice Per Line" size="small"  />
                  <FormControlLabel value="multiple" control={<Radio />} label="Multiple Invoice Per Line" size="small" />
                </RadioGroup>
              </FormControl> */}
            {/* </Box> */}
          </Grid>
        {/* </Grid> */}
      </Box>
    // </Paper>
  );
}

export default ConsolidatedInvoice;
